import {TranslateLoader} from "@ngx-translate/core";
import {CommonTranslateLoader} from "../../../../common/translate";

export const TRANSLATE_LOADER_PROVIDER = {
    loader: {
        provide: TranslateLoader,
        useFactory: () => new DashboardTranslateLoader()
    }
};

export class DashboardTranslateLoader extends CommonTranslateLoader {

    getModuleTranslation(lang: string): any {
        return require('./translations/' + lang + '/index.ts').LOCALE;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/translate/translate.loader.ts